/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';

import PullRequestLinkBase from 'src/components/pull-request-link';
import { link, overflowEllipsis } from 'src/styles/mixins';

export const PullRequestShortRow = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
});

export const PullRequestId = styled.div({
  flex: 0.7,
  textAlign: 'right',
  paddingTop: `${gridSize() / 4}px`,
  paddingRight: `${gridSize() / 2}px`,
});

export const PullRequestState = styled.div({
  flex: 1,
});

export const PullRequestTitle = styled.div(
  {
    flex: 3,
    paddingTop: '1px',
    marginLeft: `${gridSize() / 2}px`,
  },
  overflowEllipsis()
);

export const PullRequestLink = styled(PullRequestLinkBase)(link);
